import React, { useState } from 'react';
import './Sidebar.css';

const EmployeeSidebar = ({ 
  activeView,
  onViewChange,
  user,
  onLogout,
  onBackToMain,
  isMobileOpen,
  onMobileClose
}) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const menuItems = [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: '📊',
      description: 'My Covers',
      view: 'dashboard'
    },
    {
      id: 'purchase-cover',
      label: 'Purchase Cover',
      icon: '🛡️',
      description: 'Buy Insurance',
      view: 'purchase-cover'
    },
    {
      id: 'extend-policy',
      label: 'Buy/Extend Policy',
      icon: '🔁',
      description: 'Buy or extend policy',
      view: 'extend-policy'
    },
    {
      id: 'certificate-recovery',
      label: 'Check Certificate Status',
      icon: '🔧',
      description: 'Track and fix failed covers',
      view: 'certificate-recovery'
    },
    {
      id: 'generate-quote',
      label: 'Generate Quote',
      icon: '📋',
      description: 'Get a Quote',
      view: 'quote',
      action: () => window.open('http://quotations.monarchinsurance.co.ke/', '_blank')
    },
    {
      id: 'support',
      label: 'Support',
      icon: '💬',
      description: 'Get Help',
      view: 'support',
      action: () => window.open('https://wa.me/254738669931?text=hello', '_blank')
    }
  ];

  const handleItemClick = (item) => {
    if (item.action) {
      item.action();
    } else if (item.view && onViewChange) {
      onViewChange(item.view);
    }
    if (onMobileClose) {
      onMobileClose();
    }
  };

  return (
    <aside className={`sidebar ${isCollapsed ? 'collapsed' : ''} ${isMobileOpen ? 'mobile-open' : ''}`}>
      <div className="sidebar-header">
        <div className="sidebar-logo">
          <div className="logo-icon">🛡️</div>
          {!isCollapsed && (
            <div className="logo-text">
              <h2>Employee Portal</h2>
              <span>Dashboard</span>
            </div>
          )}
        </div>
        
        <button 
          className="collapse-btn"
          onClick={() => setIsCollapsed(!isCollapsed)}
          title={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          {isCollapsed ? '▶' : '◀'}
        </button>
        
        {/* Mobile Close Button */}
        <button 
          className="mobile-close-btn"
          onClick={onMobileClose}
          title="Close menu"
          aria-label="Close menu"
        >
          ✕
        </button>
      </div>

      <nav className="sidebar-nav">
        <ul className="nav-list">
          {menuItems.map((item) => (
            <li key={item.id} className="nav-item">
              <button
                className={`nav-link ${activeView === item.view ? 'active' : ''}`}
                onClick={() => handleItemClick(item)}
                title={isCollapsed ? item.label : ''}
              >
                <span className="nav-icon">{item.icon}</span>
                {!isCollapsed && (
                  <div className="nav-content">
                    <span className="nav-label">{item.label}</span>
                    <span className="nav-description">{item.description}</span>
                  </div>
                )}
                {activeView === item.view && (
                  <div className="active-indicator"></div>
                )}
              </button>
            </li>
          ))}
        </ul>
      </nav>

      <div className="sidebar-footer">
        <div className="user-section">
          <div className="user-avatar">
            {user?.fullName?.charAt(0).toUpperCase() || user?.username?.charAt(0).toUpperCase() || 'E'}
          </div>
          {!isCollapsed && (
            <div className="user-info">
              <span className="user-name">{user?.fullName || user?.username || 'Employee'}</span>
              <span className="user-role">Employee</span>
            </div>
          )}
        </div>
        
        <div className="footer-actions">
          <button 
            className="back-to-main-btn"
            onClick={onBackToMain}
            title={isCollapsed ? 'Main App' : ''}
          >
            <span className="back-icon">🏠</span>
            {!isCollapsed && <span>Main App</span>}
          </button>
          <button 
            className="logout-btn"
            onClick={() => {
              onLogout();
              if (onMobileClose) onMobileClose();
            }}
            title={isCollapsed ? 'Logout' : ''}
          >
            <span className="logout-icon">🚪</span>
            {!isCollapsed && <span>Logout</span>}
          </button>
        </div>
      </div>
    </aside>
  );
};

export default EmployeeSidebar;
